/**
 * Copyright © 2019 2020 2021 7thCode.(http://seventh-code.com/)
 * This software is released under the MIT License.
 * opensource.org/licenses/mit-license.php
 */

"use strict";

import {Directive, EventEmitter, HostListener, Input, Output} from "@angular/core";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {IErrorObject} from "../../../../../types/platform/universe";
import {GuestsService} from "../guests.service";
import {YesNoDialogComponent} from "../../../platform/base/components/yes-no-dialog/yes-no-dialog.component";
import {PaymentService} from "../../payment/payment.service";

@Directive({
	selector: "[unsubscribe-dialog]",
})

export class UnsubscribeDialogDirective {

	@Input() public account: any;
	@Output() public success = new EventEmitter<any>();
	@Output() public error = new EventEmitter<any>();

	private resultDialogContent: any = {title: "退会", message: "この会員を未入会にします。よろしければOKを押してください。"};

	constructor(
		private matDialog: MatDialog,
		private accountService: GuestsService,
		private stripeService: PaymentService,
	) {
	}

	/*
	* */
	private Complete(type: string, value: any): void {
		this.success.emit({type, value});
	}

	/*
	* */
	private Error(type: string, value: any): void {
		this.error.emit({type, value});
	}

	/*
	* */
	@HostListener("click", ["$event.target"])
	public unSubscribeAtDialog(): void {

		const dialog: MatDialogRef<any> = this.matDialog.open(YesNoDialogComponent, {
			width: "50%",
			minWidth: "320px",
			height: "fit-content",
			panelClass: "dark-card",
			data: {
				content: this.resultDialogContent,
			},
			disableClose: true,
		});

		dialog.afterClosed().subscribe((result: object): void => {
			if (result) { // if not cancel then
				this.stripeService.cancel_subscribe_at(this.account, (error: IErrorObject, result: any) => {
					if (!error) {
						this.Complete("", result);
					} else {
						this.Error("error", error);
					}
				});
			}
		});
	}

}
